var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { theme } from '../theme';
import * as Headers from './headers';
import * as Paragraphs from './paragraphs';
import * as Labels from './labels';
var MultiVariantHeaderStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  .mobile {\n    display: block;\n    @media (min-width: ", "px) {\n      display: none;\n    }\n  }\n  .tablet {\n    display: none;\n    @media (min-width: ", "px) AND (max-width: ", "px) {\n      display: block;\n    }\n  }\n  .desktop {\n    display: none;\n    @media (min-width: ", "px) {\n      display: block;\n    }\n  }\n"], ["\n  color: ", ";\n  .mobile {\n    display: block;\n    @media (min-width: ", "px) {\n      display: none;\n    }\n  }\n  .tablet {\n    display: none;\n    @media (min-width: ", "px) AND (max-width: ", "px) {\n      display: block;\n    }\n  }\n  .desktop {\n    display: none;\n    @media (min-width: ", "px) {\n      display: block;\n    }\n  }\n"])), function (props) { return (props.color ? props.color : theme.primaryColours.aubergine.main); }, theme.grid.resolution.tablet.width, theme.grid.resolution.tablet.width, theme.grid.resolution.desktop.width -
    1, theme.grid.resolution.desktop.width);
export var MultiVariantCopy = function (_a) {
    var text = _a.text, resolutions = _a.resolutions, className = _a.className, type = _a.type, color = _a.color;
    var desktop = resolutions.desktop, tablet = resolutions.tablet, mobile = resolutions.mobile;
    var DesktopText;
    var TabletText;
    var MobileText;
    if (type === 'paragraph') {
        if (desktop)
            DesktopText = Paragraphs["Paragraph".concat(desktop)];
        if (tablet)
            TabletText = Paragraphs["Paragraph".concat(tablet)];
        if (mobile)
            MobileText = Paragraphs["Paragraph".concat(mobile)];
    }
    else if (type === 'label') {
        if (desktop)
            DesktopText = Labels[desktop];
        if (tablet)
            TabletText = Labels[tablet];
        if (mobile)
            MobileText = Labels[mobile];
    }
    else {
        if (desktop)
            DesktopText = Headers[desktop];
        if (tablet)
            TabletText = Headers[tablet];
        if (mobile)
            MobileText = Headers[mobile];
    }
    return (_jsxs(MultiVariantHeaderStyle, __assign({ color: color }, { children: [DesktopText && _jsx(DesktopText, __assign({ className: "".concat(className, " desktop") }, { children: text })), TabletText && _jsx(TabletText, __assign({ className: "".concat(className, " tablet") }, { children: text })), MobileText && _jsx(MobileText, __assign({ className: "".concat(className, " mobile") }, { children: text }))] })));
};
export var MultiVariantHeader = function (props) { return _jsx(MultiVariantCopy, __assign({}, props, { type: "header" })); };
export var MultiVariantParagraph = function (props) { return _jsx(MultiVariantCopy, __assign({}, props, { type: "paragraph" })); };
export var MultiVariantLabel = function (props) { return _jsx(MultiVariantCopy, __assign({}, props, { type: "label" })); };
var templateObject_1;
